export class DmvCostDataRequest {
	newTagCode: string;
	renewalOptionID: number;
}
